import ImageService from 'lib/ImageService'
import { IMEventBus } from "lib/mp-stjk-im-service"
// import {getPrivateUrl,getPublicImageUrl,getPublicImageUrl} from '../../../../lib/ImageService'

Component({
  externalClasses: ["class-name"],
  /**
   * 组件的属性列表
   */
  properties: {
    size: String,
    isNew: Boolean,
    tfsKey: {
      type: String,
      value: "",
      observer: function (tfs) {
        this.setData({
          content: ""
        });
      }
    },
    imgUrls: {
      type: Array,
      value: []
    }
  },


  /**
   * 组件的初始数据
   */
  data: {
    content: ""
  },


  /**
   * 组件的方法列表
   */
  methods: {
    handleShowPreviewImage: function (e) {
      // let current = ImageService.getPrivateUrl(this.data.tfsKey)
      let current = getPrivateUrl(this.data.tfsKey)
      let imgs = []
      console.log(this.properties.imgUrls)
      if (this.properties.imgUrls && this.properties.imgUrls.length) {
        this.properties.imgUrls.map((imgUrl) => {
          const isPublic = imgUrl.indexOf('${public}')===0
          if(imgUrl.indexOf(this.data.tfsKey) >= 0 ){
            current = isPublic?ImageService.getPublicImageUrl(this.data.tfsKey):ImageService.getPrivateUrl(this.data.tfsKey)
            // current = isPublic?getPublicImageUrl(this.data.tfsKey):getPrivateUrl(this.data.tfsKey)
            imgs.push(current)
          }else {
            imgs.push(isPublic?ImageService.getPublicImageUrl(imgUrl.replace('${public}', '')):ImageService.getPrivateUrl(imgUrl))
            // imgs.push(isPublic?getPublicImageUrl(imgUrl.replace('${public}', '')):getPrivateUrl(imgUrl))
          }
        })
        // 支持多图浏览
        wx.previewImage({
          current, // 当前显示图片
          urls: imgs // 需要预览的图片
        });
      } else {
        // 默认展示单图浏览
        wx.previewImage({
          urls: [current]
        });
      }
    },
    // 处理图片加载完成 如果im页面需要通知滚动条滚动到最下面
    handleImgLoad() {
      if (this.data.isNew) {
        IMEventBus.trigger("REFRESH_SCROLLER");
      }
    }
  },
  ready: function () { }
});
